import getColor from './colors';

export const formatDistance = (distance) => {
  if (distance < 1000) {
    return `${distance} m`;
  }
  return `${(distance / 1000).toFixed(2)} km`;
};

export const locationName2URL = (placeName, city, width) => {
  return `${process.env.REACT_APP_BACKEND_URI}/place/photo?placeName=${encodeURIComponent(`${placeName} ${!!city ? city : ''}`)}&width=${width}&rand=${Math.floor(Math.random() * 1001)}`;
};

const getPlacePhoto = (placeName, city, width = 600) => {
  return `<img src="${locationName2URL(placeName, city, width)}" alt="" />`;
};

export const replaceLocationWithPhotos = async (text) => {
  const regex = /\[\[(.*?)\]\]/g;
  let match;
  let res = text
    .replace(/(\d+\.\s)/g, '<br />$1')
    .replaceAll(']],', ']]')
    .replaceAll(']].', ']]')
    .replaceAll(']]:', ']]');
  while ((match = regex.exec(text)) !== null) {
    const placeName = match[1];
    const photoTag = await getPlacePhoto(placeName);
    res = res.replace(`[[${placeName}]]`, `[${placeName}] ${photoTag}`);
  }
  return res;
};

const getRouteBetweenEvents = async (event1, event2) => {
  const waypoints = [
    [event1.lat, event1.lng],
    [event2.lat, event2.lng],
  ];
  const requestBody = { waypoints, mode: event2.drivingMode };

  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URI}/route`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error(`Error fetching route between events:`, error);
    return { error: 'Failed to fetch route data' };
  }
};

export const getDays = async (events) => {
  const days = {};
  if (events.length > 0) {
    events.forEach((e) => {
      days[e.day] = days[e.day] || {
        number: e.day,
        events: [],
        color: getColor(e.day),
      };
      e.number = days[e.day].events.length + 1;
      days[e.day].events.push(e);
    });
  }

  const promises = Object.keys(days).map(async (day) => {
    const dayEvents = days[day].events;
    for (let i = 0; i < dayEvents.length - 1; i += 1) {
      const route = await getRouteBetweenEvents(dayEvents[i], dayEvents[i + 1]);
      dayEvents[i + 1].route = route;
    }
    days[day].color = getColor(day);
  });

  await Promise.all(promises);

  return days;
};

export const formatDuration = (min) => {
  return !!min ? `${min} min` : '';
};
